// ============================================================
// SINGLE EDITABLE CONFIG — Turkish Docs London
// Edit business details, reviews, hours and all copy here.
// ============================================================

export const BUSINESS = {
  name: "Turkish Docs London",
  phone: "+44 7777 120 490",
  phoneRaw: "+447777120490",
  whatsapp: "447777120490",
  email: "av.mubol@gmail.com",
  // Pre-filled WhatsApp message (optional)
  whatsappMessage:
    "Merhaba, Türkiye'de kullanacağım bir belge hakkında bilgi almak istiyorum.",
  address: {
    line1: "5th Floor, The Grange",
    line2: "100 High Street",
    line3: "Southgate",
    line4: "London",
    line5: "N14 6BN",
  },
  // Opening hours — edit freely
  hours: [
    { day: "Monday – Friday", time: "09:00 – 18:00", open: true },
    { day: "Saturday", time: "By appointment", open: true },
    { day: "Sunday", time: "Closed", open: false },
  ],
  mapsEmbed:
    "https://www.google.com/maps?q=100+High+Street,+Southgate,+London+N14+6BN&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=100+High+Street,+Southgate,+London+N14+6BN",
  // Paste your Google Business Profile reviews link here when ready
  googleReviewsLink: "",
};

// ============================================================
// GOOGLE REVIEWS
// Leave empty to HIDE the reviews section.
// Add real reviews here when available — the section appears automatically.
// Example:
// { name: "Ayşe K.", rating: 5, text: "Excellent, clear help with my Power of Attorney.", date: "2026-05" }
// ============================================================
export const REVIEWS = [];

export const content = {
  en: {
    whatsappMessage:
      "Hello Turkish Docs London, I'd like help with a document for Türkiye.",
    nav: {
      services: "Services",
      why: "Why Us",
      process: "Process",
      reviews: "Reviews",
      faq: "FAQ",
      contact: "Contact",
      cta: "WhatsApp",
    },
    hero: {
      overline: "London-Based Document Support for Matters in Türkiye",
      title: "Make Your Türkiye Document Process Easier from London",
      subtitle:
        "Step-by-step support in English and Turkish for property, inheritance, vehicle, legal Power of Attorney and apostille document processes.",
      whatsapp: "Tell Us About Your Matter",
      request: "View Services",
      officeLabel: "Southgate Office",
      officeCity: "London",
      imageAlt: "Professional London office building",
    },
    trustBar: [
      "London Based",
      "English and Turkish Support",
      "Focused on Türkiye Matters",
      "Clear and Organised Process",
    ],
    why: {
      overline: "Trust & Service",
      title: "Why choose Turkish Docs London?",
      subtitle:
        "We provide Turkish and English document support for individuals and businesses across the United Kingdom.",
      items: [
        "London based service",
        "Turkish and English support",
        "Experience with Turkish document procedures",
        "Clear communication",
        "Personal assistance",
      ],
    },
    services: {
      overline: "Our Services",
      title: "What do you need to do in Türkiye?",
      subtitle:
        "Choose the option closest to your situation and send us a ready-made WhatsApp message.",
      contact: "Ask on WhatsApp",
      items: [
        {
          title: "Property Transactions & Management",
          desc: "Power of attorney support for buying, selling or managing property in Türkiye.",
          icon: "FileSignature",
          whatsappMessage: "Hello, I need a power of attorney for a property transaction in Türkiye. Could you please provide information?",
        },
        {
          title: "Inheritance matters",
          desc: "Document and power of attorney support for inheritance procedures in Türkiye.",
          icon: "Stamp",
          whatsappMessage: "Hello, I need document or power of attorney support for an inheritance matter in Türkiye. Could you please provide information?",
        },
        {
          title: "Vehicle or general power of attorney",
          desc: "Support for vehicle sale, banking, court or other power of attorney requirements.",
          icon: "FileText",
          whatsappMessage: "Hello, I need a power of attorney for a vehicle, banking, court or another matter in Türkiye. Could you please provide information?",
        },
        {
          title: "Apostille or translation",
          desc: "Support with UK documents that need apostille or certified translation for Türkiye.",
          icon: "Languages",
          whatsappMessage: "Hello, I need apostille or translation support for a UK document to be used in Türkiye. Could you please provide information?",
        },
      ],
    },
    process: {
      overline: "How It Works",
      title: "A simple, guided process",
      subtitle:
        "From your first message to documents prepared for use in Türkiye.",
      steps: [
        { title: "Contact us via WhatsApp", desc: "Send us a quick message to get started." },
        { title: "Tell us your requirement", desc: "Tell us about your document requirement." },
        { title: "We guide you", desc: "We guide you through the process step by step." },
        { title: "Ready for Türkiye", desc: "Your documents are prepared for Türkiye." },
      ],
    },
    reviews: {
      overline: "Client Feedback",
      title: "What our clients say",
      subtitle: "Trusted by Turkish-speaking clients across the UK.",
      verified: "Verified Google Review",
      cta: "Leave a Google review",
    },
    hours: {
      overline: "Visit or Contact Us",
      title: "Office & opening hours",
      subtitle:
        "Find us in Southgate, North London, or reach us anytime on WhatsApp.",
      hoursTitle: "Opening Hours",
      addressTitle: "Address",
      directions: "Get directions",
      list: [
        { day: "Monday", time: "09:00–18:00", open: true },
        { day: "Tuesday", time: "09:00–18:00", open: true },
        { day: "Wednesday", time: "09:00–18:00", open: true },
        { day: "Thursday", time: "Closed", open: false },
        { day: "Friday", time: "09:00–18:00", open: true },
        { day: "Saturday", time: "Closed", open: false },
        { day: "Sunday", time: "Closed", open: false },
      ],
    },
    pricing: {
      text: "Our services start from £199. The exact fee will always be confirmed before any work begins, depending on your requirements.",
    },
    trust: {
      assessmentTitle: "Free Initial Assessment",
      assessmentSubtitle: "No obligation.",
    },
    seo: {
      overline: "Serving the Turkish Community in the UK",
      title: "Turkish document services in London",
      paragraphs: [
        "Turkish Docs London provides document support for Turkish citizens and Turkish-speaking clients living in the United Kingdom. We help with the preparation and organisation of documents intended for use in Türkiye, including Power of Attorney for Türkiye, apostille support in London and certified translation coordination.",
        "Whether you are managing a property sale, an inheritance matter, a vehicle transaction or a general power of attorney, our London-based team offers clear, guided document assistance for Turkish citizens in the UK — in both Turkish and English.",
      ],
      tags: [
        "Turkish document services in London",
        "Power of Attorney for Türkiye",
        "Apostille support in London",
        "Document assistance for Turkish citizens in the UK",
      ],
    },
    faq: {
      overline: "Questions",
      title: "Frequently Asked Questions",
      items: [
        {
          q: "Do I need to visit your office?",
          a: "Not always. Many document matters can be started and handled remotely. Where an in-person notary appointment is required, we help you arrange it and tell you clearly if a visit is needed.",
        },
        {
          q: "Can documents be handled remotely?",
          a: "Yes, in many cases. We coordinate with you by WhatsApp, phone and email, and let you know if any specific step must be completed in person.",
        },
        {
          q: "How long does the process take?",
          a: "Depending on the type of matter, same-day appointments and document preparation may be available. Matters requiring an Apostille are usually completed within 1–3 working days. We'll confirm the expected timeframe for your specific matter during our initial discussion.",
        },
        {
          q: "Do you provide legal advice?",
          a: "If your matter relates to Turkish law, we may be able to assist. Our team includes lawyers registered with the Turkish Bar. Legal advice relating to Turkish law can be provided where appropriate. We do not provide legal advice or legal representation in relation to UK law.",
        },
        {
          q: "Can I receive support in English or Turkish?",
          a: "Yes. We assist clients in both English and Turkish throughout the entire process.",
        },
      ],
    },
    contact: {
      overline: "Get In Touch",
      title: "Speak with us today",
      subtitle:
        "If you need help with documents for Türkiye, contact us on WhatsApp or request support below.",
      whatsappCta: "Get a Free Initial Assessment on WhatsApp",
      whatsappLabel: "WhatsApp",
      callLabel: "Call",
      emailLabel: "Email",
      officeLabel: "Office",
      form: {
        heading: "Request support",
        name: "Name",
        telephone: "Telephone",
        email: "Email",
        matterType: "Matter type",
        matterTypePlaceholder: "Please select…",
        matterTypes: [
          "Property Transactions & Management",
          "Inheritance matters",
          "Vehicle or general Power of Attorney",
          "Apostille or Translation",
          "Other",
        ],
        message: "How can we help?",
        submit: "Request support",
        submitting: "Sending…",
        success: "Thank you. Your request has been received. We will be in touch shortly.",
        error: "Something went wrong. Please try again or contact us on WhatsApp.",
        continueWa: "Continue on WhatsApp",
      },
    },
    footer: {
      tagline: "Reliable document support in London for Türkiye.",
      location: "Southgate, London",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      cookie: "Cookie Policy",
      disclaimer:
        "Turkish Docs London is an independent document preparation and coordination service operating in the United Kingdom. We are not a UK regulated law firm and do not provide legal advice or legal representation in relation to UK law. Notarial services are carried out by independent Notaries Public. Our team includes lawyers registered with the Turkish Bar, and legal advice relating to Turkish law can be provided where appropriate.",
      rights: "All rights reserved.",
      quickLinks: "Quick Links",
      legalTitle: "Legal",
      contactTitle: "Contact",
      close: "Close",
    },
    mobileBar: { call: "Call" },
  },

  tr: {
    whatsappMessage:
      "Merhaba, Türkiye'de kullanacağım bir belge hakkında bilgi almak istiyorum.",
    nav: {
      services: "Hizmetler",
      why: "Neden Biz",
      process: "Süreç",
      reviews: "Yorumlar",
      faq: "S.S.S.",
      contact: "İletişim",
      cta: "WhatsApp",
    },
    hero: {
      overline: "Londra'dan Türkiye'deki İşlemleriniz İçin Belge Desteği",
      title: "Türkiye'de Yapmanız Gereken İşlemi Londra'dan Kolaylaştırın",
      subtitle:
        "Taşınmaz satışı, miras, araç, avukat vekâleti ve apostil işlemleri için gerekli belge süreçlerinde Türkçe ve İngilizce adım adım destek.",
      whatsapp: "İşleminizi WhatsApp'tan Yazın",
      request: "Hizmetleri Görün",
      officeLabel: "Southgate Ofisi",
      officeCity: "Londra",
      imageAlt: "Profesyonel Londra ofis binası",
    },
    trustBar: [
      "Londra Merkezli",
      "Türkçe ve İngilizce Destek",
      "Türkiye İşlemlerine Odaklı",
      "Açık ve Düzenli Süreç",
    ],
    why: {
      overline: "Güven & Hizmet",
      title: "Neden Turkish Docs London?",
      subtitle:
        "Birleşik Krallık'ta yaşayan bireyler ve işletmeler için Türkçe ve İngilizce belge desteği sunuyoruz.",
      items: [
        "Londra merkezli hizmet",
        "Türkçe ve İngilizce destek",
        "Türk belge işlemlerinde deneyim",
        "Açık iletişim",
        "Kişisel yardım",
      ],
    },
    services: {
      overline: "Hizmetlerimiz",
      title: "Türkiye’de hangi işlemi yapmak istiyorsunuz?",
      subtitle:
        "Size en yakın seçeneği seçin; hazır mesajla doğrudan WhatsApp’tan bilgi alın.",
      contact: "WhatsApp’tan Sorun",
      items: [
        {
          title: "Taşınmaz İşlemleri ve Yönetimi",
          desc: "Türkiye’de taşınmaz satın alma, satma veya yönetme işlemleri için vekâletname desteği.",
          icon: "FileSignature",
          whatsappMessage: "Merhaba, Türkiye’de ev/arsa alım-satım işlemi için vekâletnameye ihtiyacım var. Bilgi alabilir miyim?",
        },
        {
          title: "Miras işlemleri",
          desc: "Türkiye’deki veraset, intikal ve diğer miras işlemleri için belge ve vekâletname desteği.",
          icon: "Stamp",
          whatsappMessage: "Merhaba, Türkiye’deki miras işlemleri için belge veya vekâletname desteğine ihtiyacım var. Bilgi alabilir miyim?",
        },
        {
          title: "Araç veya genel vekâletname",
          desc: "Araç satışı, banka, dava ve diğer işlemler için ihtiyacınıza uygun vekâletname desteği.",
          icon: "FileText",
          whatsappMessage: "Merhaba, Türkiye’de araç/banka/dava veya başka bir işlem için vekâletnameye ihtiyacım var. Bilgi alabilir miyim?",
        },
        {
          title: "Apostil veya tercüme",
          desc: "İngiltere’den alınan belgelerin Türkiye’de kullanımı için apostil ve tercüme desteği.",
          icon: "Languages",
          whatsappMessage: "Merhaba, İngiltere’den aldığım bir belgeyi Türkiye’de kullanmak için apostil veya tercüme desteğine ihtiyacım var. Bilgi alabilir miyim?",
        },
      ],
    },
    process: {
      overline: "Nasıl Çalışır",
      title: "Basit ve rehberli bir süreç",
      subtitle:
        "İlk mesajınızdan Türkiye'de kullanıma hazır belgelere kadar.",
      steps: [
        { title: "WhatsApp'tan iletişime geçin", desc: "Başlamak için bize kısa bir mesaj gönderin." },
        { title: "İhtiyacınızı belirtin", desc: "Belge gereksiniminizi bize anlatın." },
        { title: "Size rehberlik ederiz", desc: "Süreç boyunca adım adım size yol gösteririz." },
        { title: "Türkiye'ye hazır", desc: "Belgeleriniz Türkiye için hazırlanır." },
      ],
    },
    reviews: {
      overline: "Müşteri Görüşleri",
      title: "Müşterilerimiz ne diyor",
      subtitle: "İngiltere'deki Türkçe konuşan müşteriler tarafından güveniliyor.",
      verified: "Doğrulanmış Google Yorumu",
      cta: "Google yorumu bırakın",
    },
    hours: {
      overline: "Bizi Ziyaret Edin",
      title: "Ofis & çalışma saatleri",
      subtitle:
        "Bizi Kuzey Londra Southgate'te bulabilir veya istediğiniz zaman WhatsApp'tan ulaşabilirsiniz.",
      hoursTitle: "Çalışma Saatleri",
      addressTitle: "Adres",
      directions: "Yol tarifi al",
      list: [
        { day: "Pazartesi", time: "09:00–18:00", open: true },
        { day: "Salı", time: "09:00–18:00", open: true },
        { day: "Çarşamba", time: "09:00–18:00", open: true },
        { day: "Perşembe", time: "Kapalı", open: false },
        { day: "Cuma", time: "09:00–18:00", open: true },
        { day: "Cumartesi", time: "Kapalı", open: false },
        { day: "Pazar", time: "Kapalı", open: false },
      ],
    },
    pricing: {
      text: "Hizmetlerimiz £199'dan başlayan fiyatlarla sunulmaktadır. İşleminizin kapsamına göre net ücret çalışmaya başlamadan önce açıkça paylaşılır.",
    },
    trust: {
      assessmentTitle: "Ücretsiz Ön Değerlendirme",
      assessmentSubtitle: "Herhangi bir yükümlülük olmadan.",
    },
    seo: {
      overline: "İngiltere'deki Türk Topluluğuna Hizmet",
      title: "Londra'da Türk belge hizmetleri",
      paragraphs: [
        "Turkish Docs London, İngiltere'de yaşayan Türk vatandaşlarına ve Türkçe konuşan müşterilere belge desteği sağlar. Türkiye için Vekaletname, Londra'da apostil desteği ve yeminli tercüme koordinasyonu dahil olmak üzere Türkiye'de kullanılmak üzere belgelerin hazırlanması ve düzenlenmesinde yardımcı oluyoruz.",
        "Bir mülk satışı, miras işlemi, araç işlemi veya genel vekaletname yönetiyor olun, Londra merkezli ekibimiz İngiltere'deki Türk vatandaşlarına hem Türkçe hem İngilizce olarak açık ve rehberli belge desteği sunar.",
      ],
      tags: [
        "Londra'da Türk belge hizmetleri",
        "Türkiye için Vekaletname",
        "Londra'da apostil desteği",
        "İngiltere'deki Türk vatandaşları için belge yardımı",
      ],
    },
    faq: {
      overline: "Sorular",
      title: "Sıkça Sorulan Sorular",
      items: [
        {
          q: "Ofisinizi ziyaret etmem gerekir mi?",
          a: "Her zaman değil. Birçok belge işlemi uzaktan başlatılabilir ve yürütülebilir. Yüz yüze noter randevusu gerektiğinde bunu ayarlamanıza yardımcı olur ve ziyaretin gerekli olup olmadığını açıkça belirtiriz.",
        },
        {
          q: "Belgeler uzaktan halledilebilir mi?",
          a: "Evet, birçok durumda. Sizinle WhatsApp, telefon ve e-posta yoluyla koordinasyon sağlar ve herhangi bir adımın yüz yüze yapılması gerekiyorsa size bildiririz.",
        },
        {
          q: "Süreç ne kadar sürer?",
          a: "İşleminizin türüne bağlı olarak aynı gün randevu ve belge hazırlığı mümkün olabilir. Apostil gerektiren işlemler ise çoğu durumda 1–3 iş günü içerisinde tamamlanmaktadır. İlk görüşmemizde işleminize özel tahmini süreyi sizinle net olarak paylaşırız.",
        },
        {
          q: "Hukuki danışmanlık sağlıyor musunuz?",
          a: "Türk hukuku ile ilgili sorularınız varsa yardımcı olabiliriz. Ekibimizde Türkiye Barosu'na kayıtlı avukatlar bulunmaktadır. Türk hukuku kapsamındaki hukuki danışmanlık gerektiğinde ekibimiz tarafından sağlanmaktadır. Birleşik Krallık hukukuna ilişkin hukuki danışmanlık veya hukuki temsil hizmeti sunmuyoruz.",
        },
        {
          q: "Türkçe veya İngilizce destek alabilir miyim?",
          a: "Evet. Süreç boyunca müşterilere hem Türkçe hem İngilizce yardımcı oluyoruz.",
        },
      ],
    },
    contact: {
      overline: "Bize Ulaşın",
      title: "Bugün bizimle görüşün",
      subtitle:
        "Türkiye için belge konusunda yardıma ihtiyacınız varsa WhatsApp'tan yazın veya aşağıdan destek talep edin.",
      whatsappCta: "WhatsApp'tan Ücretsiz Ön Değerlendirme Alın",
      whatsappLabel: "WhatsApp",
      callLabel: "Telefon",
      emailLabel: "E-posta",
      officeLabel: "Ofis",
      form: {
        heading: "Destek Talep Edin",
        name: "Ad Soyad",
        telephone: "Telefon",
        email: "E-posta",
        matterType: "İşlem türü",
        matterTypePlaceholder: "Lütfen seçin…",
        matterTypes: [
          "Taşınmaz İşlemleri ve Yönetimi",
          "Miras işlemleri",
          "Araç veya genel vekâletname",
          "Apostil veya tercüme",
          "Diğer",
        ],
        message: "Nasıl yardımcı olabiliriz?",
        submit: "Destek Talep Edin",
        submitting: "Gönderiliyor…",
        success: "Teşekkürler. Talebiniz alınmıştır. En kısa sürede sizinle iletişime geçeceğiz.",
        error: "Bir şeyler ters gitti. Lütfen tekrar deneyin veya WhatsApp'tan yazın.",
        continueWa: "WhatsApp'tan Devam Edin",
      },
    },
    footer: {
      tagline: "Türkiye için Londra'da güvenilir belge desteği.",
      location: "Southgate, Londra",
      privacy: "Gizlilik Politikası",
      terms: "Şartlar ve Koşullar",
      cookie: "Çerez Politikası",
      disclaimer:
        "Turkish Docs London, Birleşik Krallık'ta faaliyet gösteren bağımsız bir belge hazırlık ve koordinasyon hizmetidir. Birleşik Krallık'ta düzenlemeye tabi bir hukuk bürosu değildir ve Birleşik Krallık hukukuna ilişkin hukuki danışmanlık veya hukuki temsil hizmeti sunmaz. Noterlik işlemleri bağımsız Notaries Public tarafından yürütülmektedir. Ekibimizde Türkiye Barosu'na kayıtlı avukatlar bulunmaktadır. Türk hukuku kapsamındaki hukuki danışmanlık gerektiğinde ekibimiz tarafından sağlanmaktadır.",
      rights: "Tüm hakları saklıdır.",
      quickLinks: "Hızlı Bağlantılar",
      legalTitle: "Yasal",
      contactTitle: "İletişim",
      close: "Kapat",
    },
    mobileBar: { call: "Ara" },
  },
};

// ============================================================
// LEGAL POLICIES (shown in modals). Plain, editable text.
// ============================================================
export const LEGAL = {
  privacy: {
    title: "Privacy Policy",
    updated: "Last updated: June 2026",
    sections: [
      {
        h: "Who we are",
        p: "Turkish Docs London (\u201cwe\u201d, \u201cus\u201d) provides document support and coordination services from our office at 5th Floor, The Grange, 100 High Street, Southgate, London, N14 6BN.",
      },
      {
        h: "Information we collect",
        p: "When you submit our enquiry form or contact us, we collect your name, telephone number, email address and the details of your message. This information is used solely to respond to your enquiry and provide our services.",
      },
      {
        h: "How we use your information",
        p: "We use your information to respond to enquiries, coordinate document support and communicate with you about your requirements. We do not sell your personal data to third parties.",
      },
      {
        h: "Data retention",
        p: "We retain enquiry information only for as long as necessary to provide our services and to comply with legal obligations.",
      },
      {
        h: "Your rights",
        p: "Under UK GDPR you may request access to, correction of, or deletion of your personal data. To exercise these rights, contact us at av.mubol@gmail.com.",
      },
      {
        h: "Contact",
        p: "For any privacy questions, email av.mubol@gmail.com or call +44 7777 120 490.",
      },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    updated: "Last updated: June 2026",
    sections: [
      {
        h: "Our service",
        p: "Turkish Docs London provides document support, guidance and preparation assistance for documents intended for use in T\u00fcrkiye. We are not a regulated law firm and do not provide legal advice or legal representation.",
      },
      {
        h: "No legal advice",
        p: "Nothing on this website or provided by us constitutes legal advice. Notarial acts are carried out by independent notaries. You remain responsible for ensuring your documents meet the requirements of the relevant authorities.",
      },
      {
        h: "Your responsibilities",
        p: "You agree to provide accurate information. Timeframes and outcomes depend on third parties such as notaries, translators and apostille authorities and are not guaranteed by us.",
      },
      {
        h: "Limitation of liability",
        p: "To the maximum extent permitted by law, we are not liable for delays or outcomes caused by third parties or by incomplete or inaccurate information provided to us.",
      },
      {
        h: "Governing law",
        p: "These terms are governed by the laws of England and Wales.",
      },
    ],
  },
  cookie: {
    title: "Cookie Policy",
    updated: "Last updated: June 2026",
    sections: [
      {
        h: "About cookies",
        p: "Cookies are small text files placed on your device. This website uses a minimal number of cookies to ensure the site functions correctly and to understand basic, anonymous usage.",
      },
      {
        h: "Cookies we use",
        p: "We may use essential cookies required for the website to operate and basic analytics to measure visits and interactions (such as WhatsApp button clicks). We do not use cookies to identify you personally.",
      },
      {
        h: "Managing cookies",
        p: "You can control or delete cookies through your browser settings. Disabling cookies may affect how the website functions.",
      },
      {
        h: "Contact",
        p: "For questions about this Cookie Policy, email av.mubol@gmail.com.",
      },
    ],
  },
};
